var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"static-page"},[_c('StaticPageHero',{attrs:{"breadcrumbs":_vm.breadcrumbsItems,"title":_vm.title}}),_vm._v(" "),_c('section',[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }